
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class SicilAramaAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "SicilArama/SicilArama";
        super(baseUrl);
    }


    sicilArama(request: SicilAramaRequest) {

        return this.post("", request);

    }

}
export default new SicilAramaAPI();

class SicilAramaRequest {
    adi?: string;
    soyadi?: string;
    vatandaslikNo?: string;
    babaAdi?: string;
    unvan?: string;
    vergiNo?: string;
    nufusCuzdanSeriNo?: string;
    dogumTarihi?: Date;

    constructor(
        adi?: string,
        soyadi?: string,
        vatandaslikNo?: string,
        babaAdi?: string,
        unvan?: string,
        vergiNo?: string,
        nufusCuzdanSeriNo?: string,
        dogumTarihi?: Date,
    ) {
        this.adi = adi;
        this.soyadi = soyadi;
        this.vatandaslikNo = vatandaslikNo;
        this.babaAdi = babaAdi;
        this.unvan = unvan;
        this.vergiNo = vergiNo;
        this.nufusCuzdanSeriNo = nufusCuzdanSeriNo;
        this.dogumTarihi = dogumTarihi;
    }
}
export { SicilAramaRequest };